var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ServiceType } from 'app/core/service-type.model';
import { LocalStorageService } from 'app/services/storage/local-storage.service';
import { Savable } from 'app/services/storage/savable';
import { distinctUntilChanged, filter, map, shareReplay, startWith } from 'rxjs/operators';
var UserSettingsService = /** @class */ (function (_super) {
    __extends(UserSettingsService, _super);
    function UserSettingsService(_localStorageService) {
        var _this = _super.call(this, _localStorageService) || this;
        _this._localStorageService = _localStorageService;
        _this.restore();
        _this.serviceType$ = _this._localStorageService.changeKey
            .pipe(filter(function (change) { return change.key === 'userSettings'; }), map(function () { return _this.serviceType; }), startWith(_this.serviceType), distinctUntilChanged(), shareReplay());
        return _this;
    }
    Object.defineProperty(UserSettingsService.prototype, "defaultApplication", {
        get: function () {
            return this.defaultApplications[this.serviceType];
        },
        set: function (application) {
            this.defaultApplications[this.serviceType] = application;
            this.save();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserSettingsService.prototype, "orderSettings", {
        get: function () {
            return {
                region: this.region,
                exportFormat: this.exportFormat,
                verificationType: this.verificationType
            };
        },
        set: function (orderSettings) {
            this.region = orderSettings.region;
            this.exportFormat = orderSettings.exportFormat;
            this.verificationType = orderSettings.verificationType;
        },
        enumerable: true,
        configurable: true
    });
    UserSettingsService.prototype.restore = function () {
        var restored = _super.prototype.restore.call(this);
        this.serviceType = restored.serviceType || ServiceType.InvoiceCapture;
        this.documentType = restored.documentType || 'invoice';
        this.visibleInvoicesUploadArea = Savable.boolean(restored.visibleInvoicesUploadArea, true);
        this.welcomeTraining = Savable.boolean(restored.welcomeTraining, false);
        this.region = restored.region || 'US';
        this.exportFormat = restored.exportFormat || restored.format || 'Xml';
        this.verificationType = restored.verificationType || restored.verification || 'Troubleshooting';
        this.rememberImportSettings = restored.rememberImportSettings || false;
        this.defaultApplications = restored.defaultApplications || { 'ic': null, 'dc': null };
        return this;
    };
    __decorate([
        Savable.property,
        __metadata("design:type", String)
    ], UserSettingsService.prototype, "serviceType", void 0);
    __decorate([
        Savable.property,
        __metadata("design:type", String)
    ], UserSettingsService.prototype, "documentType", void 0);
    __decorate([
        Savable.property,
        __metadata("design:type", Boolean)
    ], UserSettingsService.prototype, "visibleInvoicesUploadArea", void 0);
    __decorate([
        Savable.property,
        __metadata("design:type", Boolean)
    ], UserSettingsService.prototype, "welcomeTraining", void 0);
    __decorate([
        Savable.property,
        __metadata("design:type", String)
    ], UserSettingsService.prototype, "region", void 0);
    __decorate([
        Savable.property,
        __metadata("design:type", String)
    ], UserSettingsService.prototype, "exportFormat", void 0);
    __decorate([
        Savable.property,
        __metadata("design:type", String)
    ], UserSettingsService.prototype, "verificationType", void 0);
    __decorate([
        Savable.property,
        __metadata("design:type", Boolean)
    ], UserSettingsService.prototype, "rememberImportSettings", void 0);
    __decorate([
        Savable.property,
        __metadata("design:type", Object)
    ], UserSettingsService.prototype, "defaultApplications", void 0);
    UserSettingsService = __decorate([
        Savable.key('userSettings'),
        __metadata("design:paramtypes", [LocalStorageService])
    ], UserSettingsService);
    return UserSettingsService;
}(Savable));
export { UserSettingsService };
